<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="mt-8">
          <v-card-title class="text-center text-h4 py-4">
            Login
          </v-card-title>
          
          <v-card-text>
            <v-alert
              v-if="error"
              type="error"
              class="mb-4"
            >
              {{ error }}
            </v-alert>

            <v-form @submit.prevent="handleSubmit">
              <v-text-field
                v-model="username"
                label="Username"
                type="text"
                required
                :disabled="loading"
              ></v-text-field>

              <v-text-field
                v-model="password"
                label="Password"
                type="password"
                required
                class="my-4"
                :disabled="loading"
              ></v-text-field>

              <v-btn
                color="primary"
                type="submit"
                block
                :loading="loading"
                class="mt-4"
              >
                Login
              </v-btn>

              <div class="text-center mt-4">
                Don't have an account?
                <router-link to="/signup">Sign Up</router-link>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'

const router = useRouter()
const authStore = useAuthStore()

const username = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')

const handleSubmit = async () => {
  loading.value = true
  error.value = ''
  
  try {
    await authStore.login(username.value, password.value)
    router.push(router.currentRoute.value.query.redirect || '/')
  } catch (err) {
    console.log(err)
    error.value = 'Invalid username or password'
  } finally {
    loading.value = false
  }
}
</script> 